import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "clare-update-provider-warning",
    templateUrl: "./update-provider-warning.component.html",
    styleUrls: ["./update-provider-warning.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateProviderWarningComponent {
    @Input() error?: string;
    @Input() isOnline = true;

    @Output() onFormSubmit = new EventEmitter<null>();

    onSubmit() {
        this.onFormSubmit.emit(null);
    }
}
